import { render, staticRenderFns } from "./gruop.vue?vue&type=template&id=235b9a06&"
import script from "./gruop.vue?vue&type=script&lang=js&"
export * from "./gruop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports